import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-loading';
import './bin-issue-reporter';

class BinIssueReporterModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-issue-reporter-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#bin-issue-reporter-modal {
          --modal-max-width: 1000px;
          --modal-min-width: 60%;
          --modal-min-height: 25%;
          --modal-max-height: 800px;
          --modal-body-display: flex;
        }
        bin-issue-reporter {
          height: 100%;
          align-self: center;
          width: 100%;
        }
        .title {
          margin: 0;
        }
      </style>

      <h3 class="title" slot="title">Report An Issue</h3>

      ${this._renderModalBody()}
    `;
  }

  _renderModalBody() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      <bin-issue-reporter
        .href="${this.href}"
        @cancel="${this.close}"
      >
      </bin-issue-reporter>
    `;
  }
}

window.customElements.define('bin-issue-reporter-modal', BinIssueReporterModal);
